module.exports = __webpack_public_path__ + "img/carousel_3.f06366de.png";